import styled, { keyframes } from 'styled-components';

// Animações
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Container principal
export const MainContainer = styled.div`
  position: relative;
  display: flex;
  //flex-direction: column;
  //align-items: center;
  width: 100%;
  height: 100%;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;

export const HeaderSection = styled.header`
  display: grid;
  grid-template-columns: 1fr auto 1fr; /* Espaço igual dos lados */
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 1rem;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  grid-column: 2; /* Coloca no meio */

  @media screen and (max-width: 768px) {
    grid-column: 1;
    order: 1;
  }
`;

// Título principal
export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: center;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// Subtítulo
export const Subtitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--text-heading);
  margin: 0;
  letter-spacing: 0.05em;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-column: 3; /* Coloca na terceira coluna (direita) */
  margin-right: 2vw;

  @media screen and (max-width: 768px) {
    grid-column: 1;
    justify-content: center;
    order: 2;
  }
`;


// Botão de ação
export const ActionButton = styled.button`
  position: relative;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  border-radius: 20px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 20vw;
  height: 26vh;
  overflow: hidden;
  
  /* Pseudo-elemento para o gradiente de fundo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      var(--accent-secondary-soft) 0%, 
      var(--accent-soft) 100%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 20px;
    z-index: 1;
    box-shadow: inset 0 0 20px var(--accent-soft);
  }
  
  /* Pseudo-elemento para a sombra externa que se move junto */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: transparent;
    box-shadow: 0 12px 32px var(--accent-soft);
    opacity: 0;
    transition: all 0.4s ease;
    z-index: -1;
    pointer-events: none;
  }
  
  &:hover::before {
    opacity: 1;
  }
  
  &:hover::after {
    opacity: 1;
    transform: translateY(-8px); /* Sombra se move junto com o botão */
  }
  
  &:hover {
    transform: translateY(-8px);
    border-color: var(--accent-soft);
    box-shadow: inset 0 1px 0 var(--border-subtle);
  }
  
  &:active {
    transform: translateY(-4px);
  }
  
  &:active::after {
    transform: translateY(-4px);
  }
  
  @media (max-width: 768px) {
    width: 20vw;
    height: 24vh;
    padding: 1.8rem;
  }
  
  @media (max-width: 480px) {
    width: 80vw;
    height: 20vh;
    padding: 1.5rem;
  }
  
  > * {
    position: relative;
    z-index: 2;
  }
`;

export const SmallActionButton = styled(ActionButton)`
  flex-direction: row;        
  align-items: center;        
  justify-content: center; 
  gap: 0.5rem;                
  padding: 0.8rem 1rem;
  width: 14vw;    
  height: 6vh;        

  @media (max-width: 768px) {
    padding: 0.6rem 0.8rem;
    gap: 0.4rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.6rem;
    gap: 0.3rem;
  }
`;

// Texto do botão
export const ButtonText = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: var(--accent-secondary);
  margin: 0;                  /* 🔥 remove margem que desalinhava */
  line-height: 1.3;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;


export const ProjectsList = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--surface-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--text-primary);
  border: 0.07rem solid var(--border-subtle);
  border-radius: 0.5rem;
  box-shadow: var(--shadow-sm);
  margin: 1vh;
  padding: 1.5vh 1vw;
  width: clamp(220px, 18vw, 300px);  /* mínimo 220px, ideal 18vw, máximo 300px */
  height: 55vh;
  overflow-y: auto;
  overflow-x: hidden;
`;


export const CardHeader = styled.h2`
  font-size: 8pt;
  margin-bottom: 10px;
  word-wrap: break-word; 
`;

export const StyledButton = styled.button`
  background-color: var(--brand-blue);
  border-radius: 20px;
  color: var(--text-primary);
  cursor: pointer;
  font-family: 'CerebriSans-Regular', -apple-system, system-ui, Roboto, sans-serif;
  text-align: center;
  text-decoration: none;
  transition: background-color 200ms ease, transform 150ms ease;
  border: none;
  font-size: 11px;
  width: 90px;        // largura fixa
  height: 30px;        // altura fixa
  margin: 4px;         // espaçamento entre eles
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: var(--brand-blue);
    transform: translateY(-1px);
  }

  &:active {
    background-color: var(--brand-blue);
    transform: translateY(0);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
    width: 100px;
    height: 30px;
  }
`;

export const CardContent = styled.div`
font-size: 8pt;
margin-bottom: 5px;
word-wrap: break-word; 
`;

export const TableContainer = styled.div`
  padding: 1vh 0.5vw;
  display: flex;
  width: 85%;
  box-shadow: var(--shadow-sm);
  border-radius: 20px;
  z-index: 0;
`;


// Padrão de fundo decorativo
export const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  background-image: 
    radial-gradient(circle at 25% 25%, var(--accent-secondary) 2px, transparent 2px),
    radial-gradient(circle at 75% 75%, var(--accent) 1px, transparent 1px);
  background-size: 100px 100px, 60px 60px;
  z-index: 0;
`;

// Descrição do botão
export const ButtonDescription = styled.p`
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.4;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  ${ActionButton}:hover & {
    opacity: 1;
    color: var(--text-heading);
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;


// Ícone do botão
export const ButtonIcon = styled.div`
  font-size: 1.2rem;
  display: flex;              /* 🔥 garante centralização */
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 4px 8px var(--accent-soft));

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;



export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1%;
  margin: 1%;
`;

export const SearchBox = styled.div`
  height: 8vh;
  width: 38vw;
  display: flex;
  background-color: var(--input-bg);
  margin: 0 auto;
  border-radius: 20px;
  border: 1px solid var(--accent-secondary-soft);
  overflow: hidden;
`;

export const SelectStyled = styled.select`
  display: flex;
  outline: none;
  padding-left: 0.2rem;
  font-size: 0.9rem;
  border-radius: 10px;
  border: 1px solid var(--accent-secondary-soft);
`;

export const InputStyled = styled.input`
  margin: 0.5%;
  padding: 1rem;
  border: none;
  outline: none;
  font-size: 1rem;
`;

export const ProjectListWrapper = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;     
  width: 100%;            
  height: 100%;             
  margin: 0 auto;
  overflow: hidden;         
`;

export const SearchSection = styled.div`
  width: 100%;
  margin-bottom: 2rem;         // Space between search and cards
  position: relative;
`;

// Updated ButtonGrid positioning to work better with the layout
export const ButtonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: auto;
`;




